import { render, staticRenderFns } from "./NavigationButton.vue?vue&type=template&id=33eeddcd&scoped=true&"
import script from "./NavigationButton.vue?vue&type=script&lang=js&"
export * from "./NavigationButton.vue?vue&type=script&lang=js&"
import style0 from "./NavigationButton.vue?vue&type=style&index=0&id=33eeddcd&lang=scss&scoped=true&"
import style1 from "./NavigationButton.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33eeddcd",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})


/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/newleaf.leox.dev/newleaf.leox.dev/modules/ACNLPatternTool/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33eeddcd')) {
      api.createRecord('33eeddcd', component.options)
    } else {
      api.reload('33eeddcd', component.options)
    }
    module.hot.accept("./NavigationButton.vue?vue&type=template&id=33eeddcd&scoped=true&", function () {
      api.rerender('33eeddcd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/positioned/NavigationButton.vue"
export default component.exports